import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'Páxina non atopada',
  title: 'Non atopamos esa páxina',
  body: 'Pode que a ligazón estea desfasada ou que a páxina se retirase. Díganos que busca e atoparémolo.',
  suggestionsTitle: 'Quizais busca',
  bestMatchTitle: 'Quixo dicir',
  prefillHint: 'Completado a partir do enderezo que probou',
  goHome: 'Inicio',
  browseAll: 'Todas as categorías',
  reportBrokenLink: 'Informar dunha ligazón rota',
  noticeTitle: 'Esa páxina non está dispoñible',
  noticeSearching: 'Buscando {query} no seu lugar…',
  noticePrefilled: 'Busque {query} aquí abaixo, ou díganos que busca.',
  errorTitle: 'Algo saíu mal',
  errorBody: 'Non puidemos cargar esta páxina. Ténteo de novo ou busque abaixo o que necesita.',
  retry: 'Tentar de novo',
  streamLostTitle: 'Non puidemos rematar esta páxina',
  streamLostBody: 'A busca detívose antes de que se gardase a páxina. Volva lanzala e retomarémola a partir das súas palabras.',
  relaunch: 'Buscar de novo',
};
